import { render, staticRenderFns } from "./OdMapExportsClient.vue?vue&type=template&id=480bb7be&"
import script from "./OdMapExportsClient.vue?vue&type=script&lang=js&"
export * from "./OdMapExportsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports